import 'react-app-polyfill/ie11';
// import "@babel/polyfill";

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Cookies from 'universal-cookie';
import configureStore from './store';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import App from './containers/App';
import { refreshAuthToken } from './actions/session';
import { fetchProfile, fetchMyAgentProfile, fetchSystemSettingsUrls} from './actions/profile';
import { fetchFolders } from './actions/folders';

// Initial redux state
const initialReduxState = {
    activity: { feed: {}}
};

export const store = configureStore(initialReduxState);

// Check if cookie exists
const cookies = new Cookies();
const authToken = cookies.get('authDetails');

// Check if the token is passed in for SSO
var urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('token')) {
    // Update the session token
    window.sessionStorage.setItem("APIKey", urlParams.get('token'));

    window.sessionStorage.setItem("realtorViewPortal", urlParams.get('realtorViewPortal'));

    // Remove cookie if it exists
    cookies.remove('authDetails');
}

// Check if session exists
var accessTokenFromSession = window.sessionStorage.getItem("APIKey");

// Only reload if token doesn't exist in URL
if ((authToken || accessTokenFromSession)) {
    store.dispatch(refreshAuthToken()).then(r => {
        store.dispatch(fetchProfile());
        store.dispatch(fetchMyAgentProfile());
        store.dispatch(fetchFolders());
        store.dispatch(fetchSystemSettingsUrls());
    });
}

ReactDOM.render(
    <Provider store={ store }>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
